import { EnumDictionary } from '../../../lib/enums';
import { TechnicalDataKeys } from './technical-data-keys.enum';

export const technicalDataKeysToPhraseKey: EnumDictionary<TechnicalDataKeys, string> = {
    [TechnicalDataKeys.MaxDCPowerIn]: 'COMMON.PRODUCT_TECHNICAL_DATA.MAX_DC_POWER_IN',
    [TechnicalDataKeys.MaxACPowerOut]: 'COMMON.PRODUCT_TECHNICAL_DATA.MAX_AC_POWER_OUT',
    [TechnicalDataKeys.MaxEfficiency]: 'COMMON.PRODUCT_TECHNICAL_DATA.MAX_EFFICIENCY',
    [TechnicalDataKeys.MaxModuleEfficiency]: 'COMMON.PRODUCT_TECHNICAL_DATA.MAX_EFFICIENCY',
    [TechnicalDataKeys.MaxChargingPower]: 'COMMON.PRODUCT_TECHNICAL_DATA.MAX_CHARGING_POWER',
    [TechnicalDataKeys.MaxDischargingPower]: 'COMMON.PRODUCT_TECHNICAL_DATA.MAX_DISCHARGING_POWER',
    [TechnicalDataKeys.BatteryCapacity]: 'COMMON.PRODUCT_TECHNICAL_DATA.BATTERY_CAPACITY',
    [TechnicalDataKeys.ModuleNominalPower]: 'COMMON.PRODUCT_TECHNICAL_DATA.MODULE_NOMINAL_POWER',
    [TechnicalDataKeys.Dimensions]: 'COMMON.PRODUCT_TECHNICAL_DATA.DIMENSIONS',
    [TechnicalDataKeys.Height]: 'COMMON.PRODUCT_TECHNICAL_DATA.HEIGHT',
    [TechnicalDataKeys.Length]: 'COMMON.PRODUCT_TECHNICAL_DATA.LENGTH',
    [TechnicalDataKeys.Width]: 'COMMON.PRODUCT_TECHNICAL_DATA.WIDTH',
    [TechnicalDataKeys.HeatGeneratorPower]: 'COMMON.PRODUCT_TECHNICAL_DATA.HEAT_GENERATOR_POWER',
    [TechnicalDataKeys.EnergySource]: 'COMMON.PRODUCT_TECHNICAL_DATA.ENERGY_SOURCE',
    [TechnicalDataKeys.CylinderCapacity]: 'COMMON.PRODUCT_TECHNICAL_DATA.CYLINDER_CAPACITY'
};
